/* Robbel3D Produktseite – Ergänzungen direkt in den Warenkorb (Webstra, Oktober 2026) */
if (!customElements.get('r3d-addons')) {
  customElements.define('r3d-addons', class R3dAddons extends HTMLElement {
    connectedCallback() {
      this.status = this.querySelector('[data-status]');
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-variant-id]');
        if (button) this.add(button);
      });
    }

    async add(button) {
      if (button.disabled) return;
      const label = button.querySelector('[data-label]');
      const original = label.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'Moment …';

      try {
        const root = (window.theme?.routes?.root_url || window.Shopify?.routes?.root || '/').replace(/\/$/, '');
        const response = await fetch(`${root}/cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('add failed');
        label.textContent = '✓ Im Warenkorb';
        button.classList.add('is-added');
        this.status.textContent = 'Zum Warenkorb hinzugefügt.';
        R3dAddons.refreshCart(root);
      } catch (error) {
        label.textContent = original;
        this.status.textContent = 'Das hat nicht geklappt. Bitte versuche es noch einmal.';
      } finally {
        button.removeAttribute('aria-busy');
        if (!button.classList.contains('is-added')) button.disabled = false;
      }
    }

    static async refreshCart(root) {
      try {
        const cart = await (await fetch(`${root}/cart.js`)).json();
        document.querySelectorAll('cart-count').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      } catch (error) { /* Warenkorb wird beim nächsten Seitenaufruf aktualisiert */ }
    }
  });
}
